// src/components/chat/ChatHeader.tsx
import React from 'react';
import { Bot, RotateCcw } from 'lucide-react';
import { useDesignColors } from '../../hooks/useDesignColors';
import { useLogos } from '../../hooks/useLogos';
import { useCustomTexts } from '../../hooks/useCustomTexts';
import { useThemeSettings } from '../../hooks/useThemeSettings';
import { useChatMessages } from '../../hooks/useChatMessages';
import { LanguageSelector } from './LanguageSelector';

export function ChatHeader() {
  const { colors } = useDesignColors();
  const { chatbotLogo } = useLogos();
  const { title, subtitle } = useCustomTexts();
  const { theme } = useThemeSettings();
  const { resetMessages } = useChatMessages();
  const isDark = theme.mode === 'dark';

  return (
    <div className={`flex items-center justify-between py-3 px-4 ${
      isDark ? 'bg-gray-800/95' : 'bg-white'
    }`}>
      <div className="flex items-center space-x-3">
        <div 
          className="w-10 h-10 rounded-lg flex items-center justify-center overflow-hidden"
          style={{
            background: chatbotLogo ? 'transparent' : `linear-gradient(to right, ${colors.gradientStart}, ${colors.gradientEnd})`,
          }}
        >
          {chatbotLogo ? (
            <img 
              src={chatbotLogo} 
              alt="Logo" 
              className="w-full h-full object-cover"
            />
          ) : (
            <Bot className="w-6 h-6 text-white" />
          )}
        </div>
        <div>
          <h3 
            className="text-base font-semibold bg-clip-text text-transparent leading-tight"
            style={{
              backgroundImage: `linear-gradient(to right, ${colors.gradientStart}, ${colors.gradientEnd})`,
            }}
          >
            {title}
          </h3>
          <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            {subtitle}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <LanguageSelector />
        <button
          onClick={resetMessages}
          className={`p-2 rounded-lg transition-colors ${
            isDark 
              ? 'text-gray-400 hover:text-white hover:bg-white/5' 
              : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'
          }`}
          title="Réinitialiser la conversation"
        >
          <RotateCcw className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
